import { GradientFrame } from 'data/GradientFrame';
import { ShapeFrame } from 'data/ShapeFrame';
import { editedSolidColor } from 'state/actions';
import { getFrameById } from 'state/FlyerState';
import RootState from 'state/RootState';
import { Command, CommandFunction } from './Command';

const editColors = (frameId: string, colors: string[]) => {
  return (dispatch: Function, getState: () => RootState) => {
    const { flyer } = getState();
    const frame = getFrameById(flyer, frameId);
    if (
      frame &&
      (frame instanceof GradientFrame || frame instanceof ShapeFrame)
    ) {
      frame.colors = colors;
      dispatch(editedSolidColor());
    }
  };
};

export class EditGradientColorsCommand extends Command {
  frameId: string;
  initialColors: string[];
  finalColors: string[];
  constructor(frameId: string, initialColors: string[], finalColors: string[]) {
    super();
    this.frameId = frameId;
    this.initialColors = initialColors;
    this.finalColors = finalColors;
    this.canMerge = true;
  }
  execute(): CommandFunction {
    return editColors(this.frameId, this.finalColors);
  }
  undo(): CommandFunction {
    return editColors(this.frameId, this.initialColors);
  }
  merge(nextCommand: Command): void {
    if (nextCommand instanceof EditGradientColorsCommand) {
      this.finalColors = nextCommand.finalColors;
    }
  }
}



// WEBPACK FOOTER //
// ./src/state/commands/EditGradientColorsCommand.ts